import React from 'react'
import {InlineLoader} from '@modifi/ui'
import {LoadingWrapper, SuggestionContainerDiv} from './styles'

type SuggestionContainerFactoryOptions = {
  loadingSuggestions?: boolean
  hasResults?: boolean
  noResultsMessage?: React.ReactNode
}

type SuggestionContainerProps = {
  containerProps?: Record<string, unknown>
  children?: React.ReactNode
}

export const SuggestionContainerFactory = ({
  loadingSuggestions,
  hasResults,
  noResultsMessage,
}: SuggestionContainerFactoryOptions = {}): React.FC<SuggestionContainerProps> => {
  const SuggestionContainer: React.FC<SuggestionContainerProps> = ({
    containerProps = {},
    children = null,
  }) => (
    <SuggestionContainerDiv {...containerProps}>
      {loadingSuggestions ? (
        <LoadingWrapper>
          <InlineLoader />
        </LoadingWrapper>
      ) : null}
      {children}
      {hasResults === false && (
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/interactive-supports-focus
        <div className="react-autosuggest__suggestion--add-new">{noResultsMessage}</div>
      )}
    </SuggestionContainerDiv>
  )
  return SuggestionContainer
}
